import React, { useState, useEffect, useContext } from "react";
import { Col } from "reactstrap";
// import { DatePicker } from "jalali-react-datepicker";
import ReactDatePicker from "react-datepicker";
import RoundSlider from "../RoundSlider";
import { LumpSection } from "../../context/LumpContext";
import { useTranslation } from "react-i18next";
var days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
const Time = () => {
  const { t } = useTranslation();
  const { ShowHideLumpFunction } = useContext(LumpSection);
  const [sliderValue, setSliderValue] = useState(0);
  const [showVal, setShowVal] = useState(0);
  const [today, setToday] = useState(null);
  const [dayIndex, setDayIndex] = useState(0);
  var daysFA = [
    t("شنبه"),
    t("یکشنبه"),
    t("دوشنبه"),
    t("سه شنبه"),
    t("چهارشنبه"),
    t("پنجشنبه"),
    t("جمعه"),
  ];
  const handleChange = (e) => {
    setSliderValue(e.value);
    let value = 0;

    switch (e.value.length) {
      case 3:
        value = e.value[2] - e.value[0];
        break;
      case 4:
        value = e.value[2] + e.value[3] - e.value[0];
        break;
      case 5:
        value = e.value[3] + e.value[4] - (e.value[0] + e.value[1]);
        break;
    }
    setShowVal(value);
  };

  useEffect(() => {
    let d = new Date();
    let dayName = days[d.getDay()];
    setToday(dayName);
  }, []);

  return (
    <div className="mb-4">
      <div className="d-flex align-items-center weatherStatus">
        <i className="circleTop icon-clock text-center"></i>
        <div className="text-center mr-4">
          <p className="m-0">{t("زمانبندی")}</p>
          <small className="text-muted-left">{t("روشن")}</small>
        </div>
      </div>
      <div style={{ minHeight: "65vh" }}>
        <div className="d-flex justify-content-between my-3">
          <span className="fn12">12:05 {t("صبح")}</span>
          <span className="fn12">12:05 {t("شب")}</span>
        </div>
        <div className="d-flex justify-content-center position-relative">
          <RoundSlider
            sliderType="range"
            update={handleChange}
            value={sliderValue}
            startAngle="270"
            endAngle="270"
            radius="135"
            min="1"
            max="13"
            step="1"
          />
          <div className="clockSection position-absolute">
            <span style={{ position: "absolute", top: "0" }}>12</span>
            <span style={{ position: "absolute", top: "50%", right: "5px" }}>
              3
            </span>
            <span style={{ position: "absolute", bottom: "0" }}>6</span>
            <span style={{ position: "absolute", top: "50%", left: "5px" }}>
              9
            </span>
            <span className="direction-ltr">{showVal + " : 00"}</span>
          </div>
        </div>
        <div className="d-flex flex-column align-items-center mt-4">
          <div className="d-flex justify-content-between mb-3 days">
            {daysFA.map((day, i) => {
              const active = dayIndex === i ? "todayActive" : "";
              return (
                <span
                  className={`fn10 p-1 mx-1 cursor ${active}`}
                  onClick={() => setDayIndex(i)}
                >
                  {day}
                </span>
              );
            })}
            {/* <span className={`fn10 p-1 mx-1 cursor ${today == 'Saturday' ? 'todayActive' : ''}`}>شنبه</span>
                        <span className={`fn10 p-1 mx-1 cursor ${today == 'Sunday' ? 'todayActive' : ''}`}>یکشنبه</span>
                        <span className={`fn10 p-1 mx-1 cursor ${today == 'Monday' ? 'todayActive' : ''}`}>دوشنبه</span>
                        <span className={`fn10 p-1 mx-1 cursor ${today == 'Tuesday' ? 'todayActive' : ''}`}>سه شنبه</span>
                        <span className={`fn10 p-1 mx-1 cursor ${today == 'Wednesday' ? 'todayActive' : ''}`}>چهارشنبه</span>
                        <span className={`fn10 p-1 mx-1 cursor ${today == 'Thursday' ? 'todayActive' : ''}`}>پنجشنبه</span>
                        <span className={`fn10 p-1 mx-1 cursor ${today == 'Friday' ? 'todayActive' : ''}`}>جمعه</span> */}
          </div>
          <div className="dateSection d-flex my-2 py-2 justify-content-around align-items-center date">
            <Col className="text-right">
              <p className="fn m-0">
                <i className="icon-clock"></i> {t("تاریخ")}
              </p>
            </Col>
            <Col>
              <ReactDatePicker />
            </Col>
            {/* <Col className="p-0">
                        <DatePicker />
                    </Col> */}
          </div>
        </div>
        <div className="d-flex justify-content-center mt-3">
          <div className="mx-3 mb-2 d-flex justify-content-center align-items-center flex-column text-center">
            <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
            <small className="fn10 mt-1">{t("تائید")}</small>
          </div>
          <div
            className="mx-3 mb-2 d-flex justify-content-center align-items-center flex-column text-center"
            onClick={() => ShowHideLumpFunction("firstPage")}
          >
            <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
            <small className="fn10 mt-1">{t("بازگشت")}</small>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Time };
